import { useState } from "react";
import {
  Button,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import Flag from "react-world-flags";
import { supportedLanguages } from "../../dummyData";
import { useDispatch } from "react-redux";
import { setLanguage } from "../../redux/action";

const LanguageSelectModal = ({ isOpen, setModalOpen }) => {
  //all local states
  const [languageSelected, setLanguageSelected] = useState("English");
  const [languageSelectedObj, setLanguageSelectedObj] = useState({
    countryCode: "GB",
    name: "English",
  });
  //all redux
  const dispatch = useDispatch();

  const onPressDoneBtn = () => {
    if (languageSelectedObj) {
      dispatch(setLanguage(languageSelectedObj));
      setModalOpen(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      fade={false}
      centered
      size="lg"
      toggle={() => setModalOpen((prev) => !prev)}
    >
      <ModalBody className="bg-white px-4" style={{ borderRadius: "40px" }}>
        <h4 className="f-5 mt-4 mb-5  text-center">Select Language</h4>
        <Container fluid>
          <Row className=" g-4">
            {supportedLanguages?.map((l, k) => (
              <Col md={6} key={k}>
                <div
                  onClick={() => {
                    setLanguageSelected(l?.name);
                    setLanguageSelectedObj(l);
                  }}
                  className="d-flex cursor-pointer align-items-center justify-content-between"
                >
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "24px" }}
                  >
                    <Flag
                      className="full-rounded object-fit-cover"
                      height={50}
                      width={50}
                      code={l?.countryCode}
                    />
                    <p className="f-5  m-0 d-block ">{l?.name}</p>
                  </div>
                  <Input
                    style={{
                      height: "20px",
                      width: "20px",
                      caretColor: "rgba(33, 0, 93, 1)",
                      border: `1px solid ${
                        languageSelected === l?.name
                          ? "rgba(33, 0, 93, 1)"
                          : "rgba(0, 0, 0, 0.28)"
                      }`,
                      backgroundColor:
                        languageSelected === l?.name
                          ? "rgba(33, 0, 93, 1)"
                          : "",
                    }}
                    className="full-rounded"
                    type="checkbox"
                    checked={languageSelected === l?.name}
                  />
                </div>
              </Col>
            ))}
          </Row>
          <Row className="justify-content-center g-0 mt-5">
            <Col md={6}>
              <Button
                // onClick={() => setModalOpen(false)}
                onClick={onPressDoneBtn}
                className="standard-rounded-btn full-width"
              >
                Done
              </Button>
            </Col>
          </Row>
        </Container>
      </ModalBody>
    </Modal>
  );
};

export default LanguageSelectModal;
